import { IDemo, ITheme } from '../types/themeInterface/index';

const sanitizeUrlPart = (str: string): string => {
  return str.toLowerCase().trim().replace(/\s+/g, '-');
};

const getCommonPreviewUrl = (theme: ITheme) => {
  if (!theme || !theme.title) {
    return '/';
  }

  const sanitizedTitle = sanitizeUrlPart(theme.title);
  const baseUrl = `https://themes.shopify.com/themes/${sanitizedTitle}`;

  // Если есть демо, добавляем /presets/
  if (theme.demoList?.[0]?.demoName) {
    const sanitizedDemoName = sanitizeUrlPart(theme.demoList[0].demoName);
    return `${baseUrl}/presets/${sanitizedDemoName}`;
  }

  // Иначе просто ссылка на тему
  return baseUrl;
};

const getCurrentPreviewUrl = (theme: ITheme, demo: IDemo) => {
  if (!theme || !theme.title || !demo || !demo.demoName) {
    return '/';
  }

  const sanitizedTitle = sanitizeUrlPart(theme.title);
  const sanitizedDemoName = sanitizeUrlPart(demo.demoName);

  return `https://themes.shopify.com/themes/${sanitizedTitle}/presets/${sanitizedDemoName}`;
};



export { sanitizeUrlPart, getCommonPreviewUrl, getCurrentPreviewUrl };
